import { useCallback } from 'react';

export type ICopyText = [
  () => {
    status: boolean;
    text: string;
  },
  (text: string) => void,
];

export const useCopyText = (): ICopyText => {
  const getSelectionText = () => {
    let txt = '';
    let txtArrayLength = 0;
    let url = window.location.href;

    txt = window.getSelection().toString();

    txtArrayLength = txt.split(' ').filter((word) => word !== '').length;

    url = url.includes('?') ? url + '&copy' : url + '?copy';

    return txtArrayLength >= 5
      ? {
          status: true,
          text: txt + ' Далее: ' + url,
        }
      : {
          status: false,
          text: undefined,
        };
  };

  const getSelectionTextExec = (element) => {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(element);
    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand('copy');

    selection.removeAllRanges();
  };

  const createTimeTextareaCopy = useCallback((text: string) => {
    const el = document.createElement('textarea');

    el.id = 'time-copy-text';

    el.innerText = text;

    el.style.position = 'absolute';
    el.style.left = '-999999px';

    document.body.appendChild(el);

    getSelectionTextExec(el);

    el.remove();
  }, []);

  return [getSelectionText, createTimeTextareaCopy];
};
